export default __webpack_public_path__ + "static/media/f2.2012e486.jpg";